import React, { useState, useRef, useEffect, isOpen, setIsOpen } from "react";

const AboutUs = () => {
    return (
        <div>
            <p>AboutUs screen</p>
        </div>
    )
}

export default AboutUs;